export default __webpack_public_path__ + "static/media/login-icon.4f0f76ae.svg";